import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { IoCaretDownSharp, IoCaretForwardSharp } from 'react-icons/io5';
export const CaretIcon = ({ isExpanded }) => {
    return (_jsx(_Fragment, { children: isExpanded ? (_jsx(IoCaretDownSharp, { className: 'caret-style', size: 10 })) : (_jsx(IoCaretForwardSharp, { className: 'caret-style', size: 10 })) }));
};
